// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"1f0d8a9f","453":"67634348","701":"af5ee9b5","736":"fea76d68","861":"28bd4ad3"}[chunkId] + ".chunk.js";
};